<template>
  <div class="careers-apply" v-if="$i18n.locale === 'bg'">
    <div class="text-group">
      <h3 class="text-accent">{{ $t('careers-apply-1') }}</h3>
      <h1>{{ $t('careers-apply-2') }}</h1>
      <h2>{{ $t('careers-apply-3') }}</h2>
      <router-link to="/careers?page=application" class="link">
        <span class="text-main-home">{{ $t('careers-apply-4') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.careers-apply {
  background-color: #b2c8d2;
  // display: none;
  padding: $sidesPadding;
  position: relative;
  margin-top: -$sidesPadding / 2;
  z-index: 0;
  @extend %flex-center;
  .text-group {
    @extend %flex-center;
    flex-direction: column;
    position: relative;
    z-index: 1;
    h1,
    h2,
    h3,
    p {
      text-align: center;
    }
  }
}
.careers-apply::before {
  background-image: url("../../../assets/img/careers/apply.jpg");
  background-size: cover;
  content: "";
  height: 100%;
  left: 0;
  opacity: 0.11;
  top: 0;
  position: absolute;
  width: 100%;
}

@media screen and (max-width: 1600px) {
  .careers-apply {
    padding: $sidesPadding1600;
    margin-top: -$sidesPadding1600 / 2;
  }
}
@media screen and (max-width: 1280px) {
  .careers-apply {
    margin-top: 0;
  }
}
@media screen and (max-width: 600px) {
  .careers-apply {
    padding: $sidesPadding600;
  }
}
</style>
